import {FullGameFetchHandler} from "../../../core/handlers/full-game.fetch-handler";
import {TOP_PERFORMERS_WIDGET} from "../top-performers-consts";
import {TopPerformersWidgetController} from "../top-performers-widget.controller";
import {TopPerformersWidgetState} from "../models/top-performers-widget.state";
import {APP_MODES} from "../../../core/consts";
import {APP} from "../../../core/app/consts";

export class TopPerformersWidgetFetchHandler extends FullGameFetchHandler {
  controller: TopPerformersWidgetController;
  state: TopPerformersWidgetState;

  async action(params) {
    const dataSource = await super.action(params);

    if(this.state.isPopulated) {
      this.controller.action(TOP_PERFORMERS_WIDGET.ACTION_TYPES.displayHandler, {
        gameId: this.controller.props.gameId,
        status: dataSource.game.statusGroup,
        sportTypeId: this.appStore.state.context.sportType?.id,
        type: this.appStore.state.settings.isWidget ? APP_MODES.standalone : APP.GOOGLE_ANALYTICS.SOURCES.topPerformers
      })
    }
  }
}
